export const config = {
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env
    .VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
  VITE_FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  VITE_LOGO_API_KEY: import.meta.env.VITE_LOGO_API_KEY,
  VITE_ENV: import.meta.env.VITE_ENV,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_RUTTER_PUBLIC_KEY: import.meta.env.VITE_RUTTER_PUBLIC_KEY,
  VITE_APP_NAME: 'Maximor AI',
  VITE_APP_URL: import.meta.env.VITE_APP_URL,
  VITE_MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
  VITE_MIXPANEL_API_HOST: import.meta.env.VITE_MIXPANEL_API_HOST,
  VITE_MIXPANEL_PROJECT_ID: import.meta.env.VITE_MIXPANEL_PROJECT_ID,
  VITE_MIXPANEL_VIEW_ID: import.meta.env.VITE_MIXPANEL_VIEW_ID,
  VITE_AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  // If the env variable is not set, default to 0
  VITE_MIXPANEL_RECORDING_PERCENT:
    Number(import.meta.env.VITE_MIXPANEL_RECORDING_PERCENT) || 0,
  VITE_SESSION_TIMEOUT:
    Number(import.meta.env.VITE_SESSION_TIMEOUT) || 24 * 60 * 60 * 1000, // 24 hours in milliseconds
  VITE_WARNING_DURATION:
    Number(import.meta.env.VITE_WARNING_DURATION) || 10 * 60 * 1000, // 10 minutes in milliseconds
  VITE_CONFIGCAT_SDK_KEY: import.meta.env.VITE_CONFIGCAT_SDK_KEY,
  VITE_GOOGLE_SHEETS_WEBHOOK_URL: import.meta.env
    .VITE_GOOGLE_SHEETS_WEBHOOK_URL as string | undefined,

  // Sigma Computing embed (demo only — secret should be server-side in production)
  VITE_SIGMA_CLIENT_ID: import.meta.env.VITE_SIGMA_CLIENT_ID as
    | string
    | undefined,
  VITE_SIGMA_CLIENT_SECRET: import.meta.env.VITE_SIGMA_CLIENT_SECRET as
    | string
    | undefined,

  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string | undefined,
};
